import { render, staticRenderFns } from "./ChatBoxLocation.vue?vue&type=template&id=46961b32&scoped=true"
import script from "./ChatBoxLocation.vue?vue&type=script&lang=js"
export * from "./ChatBoxLocation.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxLocation.vue?vue&type=style&index=0&id=46961b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46961b32",
  null
  
)

export default component.exports